import React from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { format as D3format } from 'd3';

const useStyles = makeStyles(theme => ({
    root: {
    },
    primary: {
        color: theme.palette.primary.main,
    },
    secondary: {
        color: theme.palette.secondary.main,
    },
}));

// a little color to make the msg easier to read
const ReportsToast = ({ closeToast, format, settings, total }) => {
    const classes = useStyles();
    const limit = format.key === 'csv' ? settings.csv_limit : settings.limit;
    const limited = total >= limit ? limit : false;

    return (
        <div className={classes.root}>
            Your <span className={classes.primary}>{` ${format.title} `}</span>
            Report is being generated
            {limited &&
                <div>
                    It will include the first
                    <span className={classes.secondary}>{` ${D3format(',')(limited)} `}</span>
                    of
                    <span className={classes.secondary}>{` ${D3format(',')(total)} `}</span>
                    rows
                </div>
            }
        </div>
    );
};
ReportsToast.propTypes = {
    toastProps: PropTypes.object,
    closeToast: PropTypes.func,
    settings: PropTypes.object,
    format: PropTypes.object,
    total: PropTypes.number,
};

export {
    ReportsToast as default,
};
